import { DimensionalUnit, DistanceUnit, WeightUnit } from "../abstractions";

export function convertDimension(
    startingUnits: DimensionalUnit,
    targetUnits: DimensionalUnit,
    startingValue: number
): number {
    let value = startingValue;

    if (startingUnits === targetUnits) return value;

    // Convert from any unit to cm
    if (targetUnits === DimensionalUnit.CENTIMETER) {
        switch (startingUnits) {
            case DimensionalUnit.INCH:
                return value * 2.54;
        }
    }

    // Always convert to cm first
    if (startingUnits !== DimensionalUnit.CENTIMETER)
        value = convertDimension(startingUnits, DimensionalUnit.CENTIMETER, value)

    // Convert cm to any target units
    switch (targetUnits) {
        case DimensionalUnit.INCH:
            return value / 2.54;
    }

    throw new Error(
        `Units were invalid: Start: ${startingUnits}, Target: ${targetUnits}`
    );
}

export function convertWeight(
    startingUnits: WeightUnit,
    targetUnits: WeightUnit,
    startingValue: number
): number {
    let value = startingValue;
    if (startingUnits === targetUnits) return value;

    if (targetUnits === WeightUnit.GRAM) {
        switch (startingUnits) {
            case WeightUnit.POUND:
                return value * 453.59237;
            case WeightUnit.OUNCE:
                return value * 28.34952;
            case WeightUnit.KILOGRAM:
                return value * 1000;
        }
        throw new Error(`Unsupported starting units: ${startingUnits}`)
    }

    if (startingUnits !== WeightUnit.GRAM)
        value = convertWeight(startingUnits, WeightUnit.GRAM, value)

    // Convert g to any target units
    switch (targetUnits) {
        case WeightUnit.POUND:
            return value / 453.59237;
        case WeightUnit.OUNCE:
            return value / 28.34952;
        case WeightUnit.KILOGRAM:
            return value / 1000;
    }

    throw new Error(
        `Units were invalid: Start: ${startingUnits}, Target: ${targetUnits}`
    );
}

export function convertDistance(
    startingUnits: DistanceUnit,
    targetUnits: DistanceUnit,
    startingValue: number
): number {
    let value = startingValue;

    if (startingUnits === targetUnits) return value;

    // Convert from any unit to Meters
    if (targetUnits === DistanceUnit.METERS) {
        switch (startingUnits) {
            case DistanceUnit.MILES:
                return value * 1609.344;
        }
        throw new Error(`Units were invalid: Start: ${startingUnits}, Target: ${targetUnits}`);
    }

    // Always convert to meters first
    if (startingUnits !== DistanceUnit.METERS)
        value = convertDistance(startingUnits, DistanceUnit.METERS, value)

    // Convert meters to any target units
    switch (targetUnits) {
        case DistanceUnit.MILES:
            return value / 1609.344;
    }

    throw new Error(`Units were invalid: Start: ${startingUnits}, Target: ${targetUnits}`);
}
